import { ReactNode } from 'react';
import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { QuestionIcon } from '@shared/custom-icons';

interface Props {
  header: string;
  tooltipContent: ReactNode;
}

export function ColumnHeaderWithHelpText({ header, tooltipContent }: Props) {
  return (
    <>
      <Typography variant="subtitle1" component="span" sx={{ mr: 0.5 }}>
        {header}
      </Typography>
      <Tooltip title={tooltipContent}>
        <QuestionIcon sx={{ width: 20, height: 20 }} />
      </Tooltip>
    </>
  );
}
